import { 
  BookOutlined,
  PushpinOutlined,
  FileProtectOutlined,
  AuditOutlined,
  QuestionCircleOutlined,
  CustomerServiceOutlined,
  DollarOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DollarCircleOutlined,
  UserOutlined,
  SendOutlined,
  BankOutlined,
  BarsOutlined,
  CoffeeOutlined,
  TagOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

import filesIcono from '../menus/icons/filesIcono.js'

import book from '../menus/icons/book.js'
import encuestasIcono from '../menus/icons/encuestasIcono.js'
import materiaIcono from '../menus/icons/materiaIcono.js'
import reloadIcono from '../menus/icons/reloadIcono.js'
import difusionIcono from './icons/difusionIcono.js'
import factura from "../menus/icons/factura.js";
import familia from '../menus/icons/familia'




const menuAdminAccountFacturacion = [{
  key: 'Admin',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.admin.admin',
  icon: BookOutlined,
  breadcrumb: true,
  submenu: [
    {
        key: 'Emisores',
        path: `${APP_PREFIX_PATH}/facturas/emisores`,
        title: 'sidenav.admin.emisores',
        icon: BankOutlined, 
        breadcrumb: false,
        submenu: [
        ]
    },
    {
        key: 'Usuarios',
        path: `${APP_PREFIX_PATH}/admin/usuarios/list/1`,
        title: 'sidenav.admin.usuarios.usuarios',
        icon: UserOutlined, 
        breadcrumb: true,
        submenu: [
        ]
    },
    {
      key: 'Folios',
      path: `${APP_PREFIX_PATH}/comprar-folios`,
      title: 'sidenav.admin.folios',
      icon: BookOutlined, 
      breadcrumb: true,
      submenu: [
      ]
    },
    {
        key: 'Ayuda',
        path: `${APP_PREFIX_PATH}/pages`,
        title: 'sidenav.ayuda.ayuda',
        icon: QuestionCircleOutlined,
        breadcrumb: true,
        submenu:[
        //   {
        //   key: 'ayuda-preguntas',
        //   path: `${APP_PREFIX_PATH}/pages/preguntas`,
        //   title: 'sidenav.ayuda.faq',
        //   icon: QuestionCircleOutlined,
        //   breadcrumb: true,
        //   submenu:[]
        // },
        {
          key: 'ayuda-soporte',
          path: `${APP_PREFIX_PATH}/pages/soporte`,
          title: 'sidenav.ayuda.soporte',
          icon: CustomerServiceOutlined,
          breadcrumb: true,
          submenu:[]
        },
        // {
        //     key: 'ayuda-manuales',
        //     path: `${APP_PREFIX_PATH}/pages/manuales`,
        //     title: 'sidenav.ayuda.manual',
        //     icon: book,
        //     breadcrumb: true,
        //     submenu:[]
        // },
      ]}
  ]
}]


const menuAdminAccount = [{
  key: 'Facturación',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.facturacion.facturacion',
  icon: BookOutlined,
  breadcrumb: true,
  submenu: [
    {
      key: 'Conceptos',
      path: `${APP_PREFIX_PATH}/conceptos`,
      title: 'sidenav.facturacion.conceptos',
      icon: BarsOutlined, 
      breadcrumb: false,
      submenu:[
      {
        key: 'Productos',
        path: `${APP_PREFIX_PATH}/conceptos/productos`,
        title: 'sidenav.conceptos.productos',
        icon: CoffeeOutlined,
        breadcrumb: true,
        submenu:[]
      },
      {
        key: 'Categorias',
        path: `${APP_PREFIX_PATH}/conceptos/categorias`,
        title: 'sidenav.conceptos.categorias',
        icon: TagOutlined,
        breadcrumb: true,
        submenu:[]
      },
      {
        key: 'Impuestos',
        path: `${APP_PREFIX_PATH}/conceptos/impuestos`,
        title: 'sidenav.conceptos.impuestos',
        icon: DollarCircleOutlined,
        breadcrumb: true,
        submenu:[]
      },
      ]
    },
    {
        key: 'Clientes',
        path: `${APP_PREFIX_PATH}/admin/usuarios/list/2`,
        title: 'sidenav.facturacion.clientes',
        icon: familia, 
        breadcrumb: true,
        submenu: [
        ]
    },
    {
      key: 'Facturas Emitidas',
      path: `${APP_PREFIX_PATH}/facturas/emitidas`,
      title: 'sidenav.facturacion.emitidas',
      icon: SendOutlined, 
      breadcrumb: true,
      submenu: [
      ]
    },
    {
      key: 'Nueva Factura',
      path: `${APP_PREFIX_PATH}/facturas/nueva`,
      title: 'sidenav.facturacion.nuevaFactura',
      icon: factura, 
      breadcrumb: true,
      submenu: [
      ]
    },
    // {
    //   key: 'Configuracion',
    //   path: `${APP_PREFIX_PATH}/config`,
    //   title: 'sidenav.config.config',
    //   icon: QuestionCircleOutlined,
    //   breadcrumb: true,
    //   submenu:[{
    //     key: 'Emisores_',
    //     path: `${APP_PREFIX_PATH}/config/emisores`,
    //     title: 'sidenav.config.emisores',
    //     icon: QuestionCircleOutlined,
    //     breadcrumb: true,
    //     submenu:[]
    //   },
    // ]
    // },
  ]
}]


const navigationConfig = [...menuAdminAccount,...menuAdminAccountFacturacion]

export default navigationConfig;
